import React, { useEffect, useState } from "react";
import TopNavBar from "../TopNavBar/TopNavBar";
import redXIcon from "../../assets/images/redXIcon.png";
import { useLocation, useNavigate } from "react-router-dom";
import { useTranslation } from "react-i18next";

function PaymentUnSuccessful() {
  const navigate = useNavigate();
  const location = useLocation();
  const { t } = useTranslation();
  const { planDetails } = location.state || {};
  const [quoteNumber, setQuoteNumber] = useState("");

  useEffect(() => {
    // Get the current URL query parameters
    const params = new URLSearchParams(window.location.search);
    const quoteNum = params.get("quoteNumber"); // Extract quoteNumber

    if (quoteNum) {
      setQuoteNumber(decodeURIComponent(quoteNum)); // Decode and set it in state
    }
  }, []);

  const handleSubmit = () => {
    navigate("/");
  };
  return (
    <>
      {/* <TopNavBar /> */}
      <div className="d-flex justify-content-center align-items-center ">
        <div
          className=" rounded-4 p-4 mb-3 text-center"
          style={{ maxWidth: "500px", width: "100%" }}
        >
          <img
            src={redXIcon}
            alt="redXIcon"
            className="img-fluid mx-auto failed-animate"
            style={{ width: "80px" }}
          />

          <h5 className="mt-3 mb-1  payment-success-label">
            {t("Sorry. Payment transaction failed!")}
          </h5>
          <p className=" fw-bold mb-3 payment-success-label">
            {t("Please try again later.")}
          </p>

          <div className="card shadow-sm rounded-4 p-4 ">
            <h5 className="fw-semibold mb-3 text-center ">{t("Quote Details")}</h5>

            <div className="mb-2 d-flex justify-content-between">
              <span className="text-muted">{t("Quote No")}</span>
              <span className="fw-medium">{quoteNumber}</span>
            </div>
          </div>
           <div className="d-flex justify-content-center align-item-center">
              <button
                type="button"
                onClick={handleSubmit}
                className="mt-4 btn btn-primary rounded-5 fw-bold "
              >
                {t("Go back home")}
              </button>
            </div>
        </div>
      </div>
    </>
  );
}

export default PaymentUnSuccessful;
